import _createForOfIteratorHelper from "C:/Users/RedFlag/Desktop/code/qms/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import Composition from "./comps/Composition.vue";
import FurnaceOperation from "./comps/FurnaceOperation.vue";
import Mechanics from "./comps/Mechanics.vue";
import Metalloscope from "./comps/Metalloscope.vue";
import Scrap from "./comps/Scrap.vue"; // import { provide  } from 'vue'

export default {
  name: "getFurnaceNo",
  data: function data() {
    return {
      dialogVisible: false,
      tableData: [],
      MaterialList: [],
      productlist: [],
      areaDate: null,
      model: {
        endDate: "",
        startDate: "",
        productNumber: "",
        sId: ""
      },
      row: ""
    };
  },
  components: {
    FurnaceOperation: FurnaceOperation,
    Composition: Composition,
    Mechanics: Mechanics,
    Metalloscope: Metalloscope,
    Scrap: Scrap
  },
  watch: {
    areaDate: function areaDate(val) {
      if (val && val.length !== 0) {
        this.model.startDate = val[0];
        this.model.endDate = val[1];
      } else {
        this.model.startDate = "";
        this.model.endDate = "";
      }
    }
  },
  mounted: function mounted() {
    // this.getFurnaceNo();
    this.getMaterialList();
    this.getProductLisr();

    if (this.$store.state.isAdd) {
      this.createFurnace();
    }
  },
  methods: {
    fillFurnace: function fillFurnace(sId) {
      if (sId < 10000) {
        var sIdStr = "000" + sId;
        return sIdStr.slice(-4);
      } else {
        return sId;
      }
    },
    handleCurrentChange: function handleCurrentChange(row) {
      console.log(row, 'row');
      this.row = row;
    },
    query: function query() {
      var _this = this;

      for (var key in this.model) {
        if (this.model[key] === "") {
          delete this.model[key];
        } else {
          if (key === "sId") {
            if (!parseInt(this.model[key])) {
              $gb.tip("炉号请输入数值", "warning");
              return false;
            }
          }

          if (key === "productNumber") {
            if (!parseInt(this.model[key])) {
              $gb.tip("产品编号请输入数值", "warning");
              return false;
            }
          }
        }
      }

      $api.queryFurnaceNoPc(this.model).then(function (res) {
        if (res.statusCode !== 0) {
          $gb.tip(res.msg, "error");
          return false;
        }

        console.log(res, 'res');

        if (!res.smelters) {
          $gb.tip(res.msg, "warning");
        } else {
          $gb.tip(res.msg);
        }

        _this.tableData = res.smelters;
      });
    },
    resetForm: function resetForm() {
      this.model = {
        endDate: "",
        startDate: "",
        productNumber: "",
        sId: ""
      };
      this.areaDate = null;
      this.getFurnaceNo();
    },
    getFurnaceNo: function getFurnaceNo() {
      var _this2 = this;

      $api.getFurnaceNo().then(function (res) {
        if (res.statusCode !== 0) {
          $gb.tip(res.msg, "error");
          return false;
        }

        _this2.tableData = res.smelters;
      });
    },
    addScrap: function addScrap(row) {
      if (this.row === "") {
        $gb.tip("请至少选择一项炉号", "warning");
        return false;
      }

      this.$refs.scrap.open(this.row);
    },
    viewscrap: function viewscrap(row) {
      this.$refs.scrap.open(row, false);
    },
    createFurnace: function createFurnace() {
      this.$refs.furnaceOperation.open();
    },
    editFurnace: function editFurnace(row) {
      this.$refs.furnaceOperation.open(row);
    },
    addChemicalComposition: function addChemicalComposition() {
      if (this.row === "") {
        $gb.tip("请至少选择一项炉号", "warning");
        return false;
      }

      this.$refs.composition.open(this.row);
    },
    toViewChemicalComposition: function toViewChemicalComposition(row) {
      this.$refs.composition.toView(row);
    },
    addMechanics: function addMechanics(row) {
      if (this.row === "") {
        $gb.tip("请至少选择一项炉号", "warning");
        return false;
      }

      this.$refs.mechanics.open(this.row);
    },
    viewMechanicalProperty: function viewMechanicalProperty(row) {
      this.$refs.mechanics.open(row, false, "查看力学性能");
    },
    addMetalloscope: function addMetalloscope(row) {
      if (this.row === "") {
        $gb.tip("请至少选择一项炉号", "warning");
        return false;
      }

      this.$refs.metalloscope.open(this.row);
    },
    getMaterialList: function getMaterialList() {
      var _this3 = this;

      $api.getMaterialList().then(function (res) {
        if (res.statusCode !== 0) {
          $gb.tip(res.msg, "warning");
          return;
        }

        _this3.MaterialList = res.materials;
      });
    },
    getProductLisr: function getProductLisr() {
      var _this4 = this;

      $api.getProductClass().then(function (res) {
        if (res.statusCode !== 0) {
          $gb.tip(res.msg, "error");
          return false;
        }

        _this4.productlist = res.products;
      });
    },
    editmetal: function editmetal(row) {
      this.$refs.metalloscope.toView(row);
    },
    deleteFurnace: function deleteFurnace(row) {
      var _this5 = this;

      $gb.open("是否确认删除").then(function (res) {
        $api.deleteFurnaceNo(row).then(function (res) {
          if (res.statusCode !== 0) {
            $gb.tip(res.msg, "error");
            return false;
          }

          $gb.tip("删除成功");

          _this5.getFurnaceNo();
        });
      });
    },
    productNumber: function productNumber(row) {
      if (row.endNumber !== 0 || row.startNumber !== 0) {
        var startStr = "000" + row.startNumber;
        var endStr = "000" + row.endNumber;
        return startStr.slice(-4) + "-" + endStr.slice(-4);
      } else {
        var productNubArr = row.productNumbers.split(" ");
        var str = "";

        var _iterator = _createForOfIteratorHelper(productNubArr),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            str += ("000" + item).slice(-4) + " ";
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return str;
      }
    },
    formattDate: function formattDate(row) {
      if (row.pourDate) {
        if (row.pourDate.includes(' ')) {
          var date = row.pourDate.split(" ")[0];
          var time = row.pourDate.split(" ")[1].slice(0, 5);
          return date + ' - ' + time;
        } else {
          return row.pourDate;
        }
      } else {
        return "";
      }
    }
  }
};